import './reports.css';

export const Packed: React.FC = () => <></>;
